{
  "nl": {
    "project": {
      "actions": {
        "activate": "Activeren",
        "addProjectMaintainer": "Voeg beheerder toe",
        "add_as_partner": "Toevoegen als partner",
        "add_as_partner_description": "Weet u zeker dat je {partner} als partner aan dit project wilt toevoegen?",
        "add_as_sales_partner_description": "Weet u zeker dat u {partner} als verkooppartner aan dit project wilt toevoegen?",
        "add_project_partner": "Projectpartner toevoegen",
        "add_sales_partner": "Verkooppartner toevoegen",
        "additional_information": "Extra informatie",
        "changeProjectLogin": "Verander projectafbeelding",
        "changeProjectLogo": "Verandere projectlogo",
        "deactivate": "Deactiveren",
        "edit": "Bewerken",
        "finishRequest": "Verzoek verzenden",
        "follow": "Volgen",
        "giveAccess": "Geef toegang",
        "maintainerAdd": "Voeg projectbeheerder toe",
        "maintainerAddDescription": "Ben je zeker dat je {maintainer} toegang wil geven tot dit project?",
        "maintainerRemove": "Verwijder projectbeheerder",
        "maintainerRemoveDescription": "Ben je zeker dat je {maintainer} de toegang wil ontnemen voor dit project?",
        "new": "Project",
        "next": "Volgende",
        "remove_partner": "Verwijder {partner}",
        "remove_project_partner": "Verwijder projectpartner",
        "remove_project_partner_description": "Weet je zeker dat je {partner} van projectpartners wilt verwijderen?",
        "remove_sales_partner": "Verkooppartner verwijderen",
        "remove_sales_partner_description": "Weet u zeker dat u {partner} wilt verwijderen uit verkooppartners?",
        "selectOption": "Selecteer optie",
        "selectTemplate": "Selecteer sjabloon",
        "submit": "Project maken",
        "unFollow": "Niet volgen"
      },
      "attributes": {
        "address": "Adres",
        "currency": "Munteenheid",
        "delivery_date_actual": "Verwachte einddatum",
        "delivery_date_contractual": "Contractuele einddatum",
        "description": "Omschrijving",
        "internal_note": "Interne notitie",
        "measurement": "Meeteenheid",
        "name": "Naam",
        "picture_login_url": "Projectafbeelding",
        "picture_logo_url": "Projectlogo",
        "quotity_total": "Totale quotiteit",
        "skip_building": "Skip building",
        "skip_lot": "Geen Lot?",
        "skip_phase": "Geen fase?",
        "skip_unit": "Unit verbergen (project met één unit)",
        "start_date": "Startdatum",
        "units_count": "Aangemaakte units",
        "units_count_max": "Maximum aantal units",
        "vat_percentage": "BTW %",
        "website_url": "Website-url"
      },
      "errors": {
        "capacity": {
          "cant_have_more_units": "Capaciteit bereikt, neem contact met ons op."
        }
      },
      "import": {
        "add": "+ Toevoegen",
        "add_instead": "Ik wil toch {levels} toevoegen",
        "building": "gebouw",
        "buildings": "gebouwen",
        "changed_mind": "Sla dit niveau over",
        "create_new": "Wat is de naam van het {type}",
        "download_template": "Importtemplate downloaden",
        "drop_or_upload": "Sleep de template naar hier of klik om te uploaden",
        "error_line": "Fout online",
        "fill_space_info": "Sjabloon invullen met ruimte-informatie",
        "fill_unit_info": "Template invullen met unit informatie",
        "fix_file_upload": "Los de problemen op en upload het bestand opnieuw.</br>Bestaande units worden niet verwijderd, maar worden bijgewerkt als er iets is gewijzigd in het bestand voor die unit sinds de laatste upload.",
        "fix_file_upload_space": "Los de problemen op en upload het bestand opnieuw.</br>Bestaande ruimtes worden niet verwijderd, maar worden bijgewerkt als er iets is gewijzigd in het bestand voor die ruimte sinds de laatste upload.",
        "for": "voor",
        "import_column_title": "Wil je {column_type} toevoegen?",
        "import_partial_success": "Importeren is gedeeltelijk gelukt. Hieronder staan de overige fouten:",
        "import_spaces": "Ruimtes importeren",
        "import_units": "Units importeren voor",
        "lot": "lot",
        "lots": "Loten",
        "no": "nee",
        "noLevels": "Geen {levels}",
        "phase": "fase",
        "phases": "fasen",
        "plot": "lot",
        "select_level_above": "Selecteer een {level} om verder te gaan",
        "start_upload": "Begin het uploaden",
        "step": "Stap",
        "unit_info": "Je kan units importeren zodra het project is gemaakt",
        "unit_limit": "Je wilt meer units importeren dan is toegestaan. Verwijder {exceeded_by} units of vraag ons om jouw aantal toegestane units te verhogen",
        "units": "units",
        "upload_filled_template": "Ingevulde template uploaden",
        "upload_new_file": "Nieuw bestand uploaden",
        "upload_spaces": "Ruimten uploaden",
        "upload_units": "units uploaden",
        "uploaded_file": "Geüploade bestand",
        "validations_failed": "Sommige validaties zijn mislukt",
        "yes": "ja"
      },
      "labels": {
        "activate": "Activeer project",
        "checkLevels": "Vink de niveaus aan die u wilt toevoegen:",
        "companyInfo": "Bedrijfsinformatie",
        "companyNameTitle": "Bedrijfsnaam",
        "congratulationsNewProject": "Gefeliciteerd met je nieuw project",
        "copyFromTemplate": "Projectmodel kopiëren (optioneel)",
        "customer_can_create_issue": "De klant kan nieuwe punten melden",
        "customersCanLogIn": "Klanten van dit project kunnen inloggen via",
        "deactivate": "Deactiveer project",
        "deactivated": "Gedeactiveerd",
        "download_export": "Download mijn export",
        "downloading_export": "Downloaden",
        "endsOn": "Eindigt op {enddate}",
        "export_expiration": "Uw export staat klaar om te downloaden. Deze blijft beschikbaar tot {time}",
        "export_explanation": "Vraag een export aan van al uw gegevens, inclusief gesprekken en documenten.",
        "export_failed": "Export mislukt",
        "export_file": "Exporteer mijn dossier",
        "export_notification_snack": "Het verzamelen van uw dossier kan tot enkele minuten duren. Je ontvangt een melding wanneer deze klaar is om te downloaden.",
        "export_prepared": "Jouw exportdata zal binnenkort klaar zijn om gedownload te worden.",
        "export_preparing": "Export verzamelen",
        "filterProject": "Selecteer project",
        "finalSteps": "Laatste stappen",
        "follow": "Volg {project} om notificaties te ontvangen.",
        "followedProjects": "Mijn Projecten",
        "following": "Volgend",
        "general": "Algemeen",
        "importContacts": "Ja, ik wil contacten importeren",
        "importInformationSubtitle": "In plaats van ruimtes en contacten één voor één toe te voegen, kunnen wij u helpen met het importeren van een CSV-bestand. Vink onderstaande vakjes aan en een Ziggu-teamlid neemt contact met je op.",
        "importInformationTitle": "Informatie importeren?",
        "importSpaces": "Ja, ik wil parkeer- en opslagruimten importeren",
        "importUnits": "Ja, ik wil units en hun informatie importeren",
        "included": "Inbegrepen",
        "internal": "Intern",
        "invoice_subtitle": "We sturen alleen een factuur als dat nodig is, b.v. wanneer u geen units meer in uw pakket heeft.",
        "invoice_title": "Naar welk e-mailadres kunnen we onze facturen sturen?",
        "isTemplateProject": "Dit is een projectsjabloon",
        "levelBuildingExplainer": "Selecteer dit als je meerdere units in één of meer gebouwen hebt.",
        "levelPhaseExplainer": "Selecteer dit als jouw project in verschillende fasen wordt gebouwd, gespreid over de tijd.",
        "levelPlotExplainer": "Selecteer dit als jouw project uit meerdere percelen bestaat.",
        "levelProjectExplainer": "Jouw project is de grootste bouwsteen en is essentieel om aan de slag te gaan.",
        "levelUnitExplainer": "De unit is de kleinste bouwsteen. Dit is het huis of appartement dat je bouwt voor jouw klanten.",
        "levels": "Projectstructuur",
        "limitReached": "Projectlimiet bereikt",
        "multiUnits": "Meerdere units",
        "nameTitle": "De naam van het project?",
        "newProjectTitle": "We gaan een nieuw project maken!",
        "noAccess": "Je hebt geen toegang tot dit project",
        "noFollowedProjects": "Klik op het notificatie-icoontje om een project te volgen.",
        "noProjects": "Geen projecten gevonden.",
        "optional_information": "Vrijblijvende informatie",
        "optional_information_subtitle": "Is er nog iets dat je graag met ons wilt delen?",
        "otherProjects": "Andere Projecten",
        "outOfProjects": "Het lijkt erop dat je pakket geen actieve projecten meer heeft.",
        "outOfProjectsContact": "Neem contact op met Ziggu om je pakket te vergroten en door te gaan met het maken van projecten.",
        "partner_invitation_notice": "{partner} is nog niet uitgenodigd. Een uitnodiging zal verstuurd worden van zodra {partner} toegevoegd wordt als projectpartner.",
        "pendingProjects": "{first_project_name} is aangevraagd en wordt momenteel opgezet door Ziggu | {count} projecten zijn aangevraagd en worden momenteel opgezet door Ziggu",
        "permission_partner_project": "Een partner om gemakkelijk documenten en voorstellen van dit project mee te delen",
        "permission_sales_partner": "Een partner die leads kan creëren en toewijzen aan units die te koop staan",
        "permissionsOwnerOnly": "Enkel teamleden met rol Eigenaar kunnen nieuwe projectbeheerders toevoegen.",
        "permissionsRoleMaintainer": "Een teamlid dat toegang tot dit project heeft",
        "project": "Project {project}",
        "projectBranding": "Project branding",
        "projectIsDeactivated": "Dit project is gedeactiveerd",
        "projectMaintainers": "Projectbeheerders",
        "projectName": "Naam project",
        "projectStructure": "Projectstructuur",
        "projectStructureSubtitle": "Je hebt nu de mogelijkheid om 3 extra niveaus toe te voegen om jouw units beter te organiseren.</br>Laten we ze stap voor stap doornemen.",
        "projectStructureSubtitleOld": "De projectstructuur wordt bij aanvang van het project eenmalig vastgelegd.",
        "project_label": "Project",
        "project_partners": "Projectpartners",
        "projects": "Projecten",
        "remove_project_partner_prohibited": "{partner} is toegevoegd aan beslissingen in dit project en kan niet verwijderd worden van projectpartners.",
        "remove_project_partner_prohibited_label": "Projectpartner kan niet worden verwijderd",
        "sales_partner_invitation_notice": "{partner} is nog niet uitgenodigd. Er wordt een uitnodiging verzonden wanneer {partner} wordt toegevoegd aan de verkooppartners.",
        "sales_partners": "Verkooppartners",
        "searchProject": "Zoek project",
        "searchProjects": "Zoek project",
        "selectATemplateProject": "Selecteer een projectsjabloon",
        "selected": "Geselecteerd",
        "showProject": "Project tonen",
        "singleUnit": "Eén unit",
        "spaces": "Ruimtes",
        "startsOn": "Begint op {startdate}",
        "step1Info": "Laten we enkele details doornemen om je op weg te helpen.",
        "step1Title": "Gefeliciteerd met je nieuwe project!",
        "step2Info": "Aan welk bedrijf mogen wij de factuur richten?",
        "step2Title": "Factuurgegevens",
        "step3Title": "Tussenliggende niveaus nodig?",
        "step4Info": "Wat gebeurt er nu? Ziggu zet {project} binnen 3 tot 5 werkdagen op. Je krijgt bericht zodra alles klaar is.",
        "templateProjects": "Projectsjablonen",
        "unFollow": "Geen notificaties meer ontvangen voor {project}.",
        "underConstruction": "In opbouw",
        "units": "Units",
        "unitsActiveRemaining": "BESCHIKBARE UNITS",
        "unitsAllotted": "UNITS",
        "unitsCountSubtitle": "Hoeveel units?",
        "unselected": "Klik om te selecteren",
        "youAreEditingTemplateProject": "Je bewerkt een projectsjabloon",
        "you_have_inbound_emails": "Je hebt 1 onverwerkte inkomende e-mail | Je hebt {number} onverwerkte inkomende e-mails"
      },
      "messages": {
        "units_count_max": "Meer units nodig? Gelieve ons te contacteren via de chat."
      },
      "modals": {
        "add_project": {
          "step_1": {
            "title": "Laten we jouw nieuw project opzetten!"
          },
          "step_2": {
            "title": "Bevat dit project één of meerdere units?"
          },
          "step_3": {
            "subtitle": "Klik op de kaarten om de tussenliggende niveaus te activeren.",
            "title": "De units in jouw project groeperen? "
          },
          "step_4": {
            "info": "Beslissings- en enquêtesjablonen kunnen worden geïmporteerd zodra de units voor dit project zijn gemaakt.",
            "placeholder": "Selecteer een project of laat dit leeg als je niet wilt kopiëren van een sjabloon",
            "title": "Een sjabloon als basis gebruiken?"
          }
        }
      },
      "navigation": {
        "backToProjects": "Terug naar projecten"
      },
      "notifications": {
        "emailHasBeenCopied": "E-mailadres gekopieerd",
        "pictureChangedSuccessfully": "De afbeelding is bijgewerkt. Het kan tot een uur duren voordat de wijzigingen zichtbaar zijn.",
        "tokenCopied": "Token succesvol gekopieerd",
        "urlHasBeenCopied": "URL gekopieerd"
      },
      "placeholders": {
        "employees": {
          "none": {
            "subtitle": "Je hebt geen toegang tot projecten. Vraag een teamlid met Eigenaar role om je toegang te verlenen.",
            "title": "Geen projecten"
          }
        },
        "partners": {
          "noProjectSubtitle": "Je zal een notificatie krijgen van zodra je toegewezen wordt aan een nieuw project",
          "noProjectTitle": "Nog geen project"
        }
      },
      "snackbars": {
        "duplicate": "Het kopieerproces is gestart en kan enkele ogenblikken duren. Vernieuw de pagina na een paar minuten."
      },
      "toasts": {
        "activateSuccess": "{project_name} is succesvol geactiveerd.",
        "deactivateSuccess": "{project_name} is succesvol gedeactiveerd.",
        "duplicate": "Het project is gemaakt, maar het kopiëren van de sjabloon kan enkele minuten duren."
      },
      "tooltip": {
        "hasNoActiveUnits": "Heeft geen actieve units",
        "turnOffNotifications": "Schakel notificaties uit voor {project}",
        "turnOnNotifications": "Schakel notificaties aan voor {project}"
      },
      "validation": {
        "addressInformationRequired": "Adresgegevens vereist",
        "companyNeedName": "Bedrijfsnaam vereist",
        "companyNeedVatNumber": "BTW-nummer vereist",
        "dateAfter": "Datum moet na startdatum zijn",
        "lessThanOrEqual": "Getal moet kleiner of gelijk zijn dan {max_number}",
        "maxLength": "Naam kan maximaal {length} karakters hebben",
        "nameAlreadyTaken": "Naam is al in gebruik voor dit project",
        "needName": "Naam is vereist",
        "needNumber": "Moet een nummer zijn (bv. 8400.5)",
        "needUnitsCount": "Aantal units is vereist"
      }
    }
  }
}
